<div class="input-box" [ngClass]="{'no-border': isBorder}" fxLayout="row" fxLayoutAlign="start center" [formGroup]="searchForm">
  <img class="search-icon" *ngIf="showSearchIcon" src="../../../../assets/image/svg/searh-icon.svg" />
  <input type="text" placeholder="Search" formControlName="keyword">
  <img src="../../../../assets/image/svg/close-black.svg" *ngIf="keyword?.length > 0" (click)="clearSerach()">
</div>
